





























import { Component, Vue, Prop } from "vue-property-decorator";
import { Dropdown, Input } from "@brankas/web-ui";
import { DropdownOption } from "@/types";

@Component({
  components: {
    Dropdown,
    Input,
  },
})
export default class SearchInput extends Vue {
  @Prop({ default: null }) value!: any;
  @Prop({ default: () => [] }) options!: Array<DropdownOption>;

  focusWrapper = "";

  // Methods
  onChange(value: any, name: string) {
    const filters = {
      ...this.value,
      [name]: value,
    };
    this.$emit("input", filters);
  }

  submitSearch() {
    this.$emit("submit");
  }

  onFocus() {
    this.focusWrapper = "focused-border";
  }

  onBlur() {
    this.focusWrapper = "";
  }
}
